import { styled } from '@mui/material/styles';

// eslint-disable-next-line import/prefer-default-export
export const ConnectOptionsContainer = styled('div', {
  shouldForwardProp: prop => prop !== 'hideBorder',
})(({ theme, hideBorder }) => ({
  borderBottom: `1px solid ${theme.palette.grey[100]}`,
  padding: theme.spacing(1.5, 0, 1, 0),

  ...(hideBorder && {
    borderBottom: '0px',
  }),

  '&:last-of-type': {
    borderBottom: '0px',
  },
}));
